import accountSettings from './accountSettings'
import clientProperties from './clientProperties'
import profile from './profile'
import roommatePreference from './roommatePreference'

export default {
  accountSettings,
  clientProperties,
  profile,
  roommatePreference,
}
